
export default function (selection, xScale, height, today) {
  // Draw today
  selection.selectAll('.current-day')
           .data(() => {
             if (isNaN(xScale.domain()[0].getTime())) {
               // If the x-scale doesn't have dates, we're not actually drawing anything in this gantt chart, so don't draw the current day
               return []
             }
             var next = new Date(today)
             next.setDate(next.getDate() + 1)

             var x = xScale(today)
               , width = Math.max(1, xScale(next) - xScale(today))

             return [{
               x: x - width / 2,
               width: width
              }]
           })
           .enter()
            .append('rect')
              .attr('class', 'current-day')
              .merge(selection.selectAll('.current-day'))
              .attr('x', d => d.x)
              .attr('width', d => d.width)
              .attr('y', 0)
              .attr('height', height)
}
